const LETTERS = ['ASPOMTGCZX', 'QWERTYUIOP', 'KJHGFDSAZX', 'VBNMASPORT', 'WRYIPKHFSZ', 'QETUOLJGDA'];

function getDigits(id: number) {
  const len = id.toString().length;
  const iArray = [];

  let n = id;
  for (let index = 0; index < len; index += 1) {
    iArray[index] = Math.floor(n % 10);
    n = Math.floor(n / 10);
  }

  return iArray;
}

export function encodeCid(id: number) {
  const digits = getDigits(id);

  let numberPart = '';
  let letterPart = '';

  for (let i = 0; i < digits.length; i += 1) {
    if (i % 2 === 0) {
      numberPart += digits[i];
    } else {
      letterPart += LETTERS[Math.floor(i / 2)][digits[i]];
    }
  }

  return letterPart + numberPart;
}

export function decodeCid(str: string) {
  let index = 0;
  for (; index < str.length; index += 1) {
    if (/\d/.test(str[index])) break;
  }

  const numberPart = str.substring(index);
  const letterPart = str.substring(0, index);
  let id = 0;

  for (let i = 0; i < numberPart.length; i += 1) {
    id += parseInt(numberPart[i], 10) * 100 ** i;
  }
  for (let i = 0; i < letterPart.length; i += 1) {
    id += LETTERS[i].indexOf(letterPart[i]) * 100 ** i * 10;
  }

  return id;
}
